import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { ThemeProvider, CssBaseline, createTheme, Typography, Stack, Divider, Link, Button } from '@mui/material';
import Iconify from '../../components/iconify';
import { LoginForm } from '../../sections/auth/login2';
import './LoginPage.css';
import Logo from '../../components/logo';
// ----------------------------------------------------------------------

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0b1320', 
    },
    primary: { main: '#00ffc8' },
    secondary: { main: '#00d2ff' },
  },
});

// ----------------------------------------------------------------------

export default function Login() {
  useEffect(() => {
    document.body.classList.add('auth-bg');
    return () => document.body.classList.remove('auth-bg');
  }, []);

  return (
    <>
      <Helmet>
        <title>Login | Fiber Gaming Network</title>
      </Helmet>

      <ThemeProvider theme={theme}>
        <CssBaseline />
          <div className="page-background"></div>
        <div className="page-wrapper">
          <div className="login-container">
                <Logo whiteLogo sx={{ width: 300, height: 'auto', mb: 3 }} />
            <Divider sx={{ my: 3 }}>
            </Divider>
            <LoginForm />
            <div className="register-cta">
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Don’t have an account?
                <Link href="/register" className="register-link">
                  &nbsp;Register here!
                </Link>
              </Typography>
            </div>
          </div>
        </div>
      </ThemeProvider>
    </>
  );
}